import productApi from '@/api/api_product';
import { EXP_DIV_CODE } from '@/utils/const';

const state = {
  productExpDiv: '01',
  productItems: [],
  endProductItems: [],
  loadingItems: false,
};

const mutations = {
  UPDATE_PRODCUT_EXP_DIV(state, payload) {
    state.productExpDiv = EXP_DIV_CODE[payload];
    state.productItems = [];
    state.endProductItems = [];
  },
  UPDATE_PRODUCT_ITMES(state, payload) {
    state.productItems = payload;
  },
  UPDATE_END_PRODUCT_ITMES(state, payload) {
    state.endProductItems = payload;
  },
  FAIL_UPDATE_PRODUCT_ITEMS() {
    console.log('error');
  },
  START_PRODUCT_ITEMS_LOADING() {
    state.loadingItems = true;
  },
  END_PRODUCT_ITEMS_LOADING() {
    state.loadingItems = false;
  },
};

const actions = {
  async getProductItems({ commit, state }, pgDiv) {
    try {
      commit('START_PRODUCT_ITEMS_LOADING');
      const res = await productApi.getProducts(state.productExpDiv, pgDiv);
      commit('UPDATE_PRODUCT_ITMES', res.data.response);
      commit('END_PRODUCT_ITEMS_LOADING');
    } catch (e) {
      commit('END_PRODUCT_ITEMS_LOADING');
      commit('FAIL_UPDATE_PRODUCT_ITEMS');
    }
  },
  async getEndProductItems({ commit }, pgDiv) {
    try {
      commit('START_PRODUCT_ITEMS_LOADING');
      const res = await productApi.getProducts(state.productExpDiv, pgDiv, 'end');
      commit('UPDATE_END_PRODUCT_ITMES', res.data.response);
      commit('END_PRODUCT_ITEMS_LOADING');
    } catch (e) {
      commit('END_PRODUCT_ITEMS_LOADING');
      commit('FAIL_UPDATE_PRODUCT_ITEMS');
    }
  },
  setProductExpDiv({ commit }, expDiv) {
    commit('UPDATE_PRODCUT_EXP_DIV', expDiv);
  },
};

const getters = {
  productItems: (state) => state.productItems,
  endProductItems: (state) => state.endProductItems,
  recomProductItems: (state) => {
    return state.productItems.slice(0, 4);
  },
};

const productModule = {
  state,
  mutations,
  actions,
  getters,
};

export default productModule;
